import React from "react";

export const CaloriesIcon: React.FC = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24.846"
      height="25"
      viewBox="0 0 24.846 25"
    >
      <g transform="translate(0 0)">
        <path
          data-name="Path 2197"
          d="M64.609,28.762a10.957,10.957,0,0,0-3.048-7.611A10.242,10.242,0,0,0,54.2,18H53V30H64.608ZM55.4,27.52V20.574a7.916,7.916,0,0,1,4.463,2.332,8.387,8.387,0,0,1,2.255,4.615Z"
          transform="translate(-39.763 -18)"
        />
        <path
          data-name="Path 2198"
          d="M28.469,49.555A10.776,10.776,0,0,0,39.277,39.2l.041-1.249H29.269V27.9l-1.249.041a10.81,10.81,0,1,0,.449,21.616Zm-1.6-19.063v9.856h9.856a8.407,8.407,0,1,1-9.856-9.856Z"
          transform="translate(-17.434 -24.557)"
        />
      </g>
    </svg>
  );
};
